import React, { Component } from "react";
// import Companies from "../commonComponents/Companies";
// import ReachingOut from "../commonComponents/ReachingOut";
import Subjects from "./Subjects";
import Herosection from "../commonComponents/Herosection";
import About from "./About";
// import CreateAccountForm from "../commonComponents/CreateAccountForm";
import ClientCarousel from "../commonComponents/ClientCarousel";
import Skills from "./Skills";
import { Box } from "@material-ui/core";

interface Props {
    // classes: any,
}

class Home extends Component<Props>{
    render() {
        return (
            <Box>
                <Herosection
                    heading="Education"
                    cardClass={"Herosection-herosectionLeftCards"}
                    highlight="Codezzy,"
                    herosectionTitleClassName={"Herosection-herosectionFirstTitle"}
                    herosectionClassName={"Herosection-herosectionFirstMessage"}
                    // herosectionMessage={" is an interactive learning platform"}
                    herosectionMessage={" unlocking potential, one line of code at a time"}
                    herosectionBody={"Herosection-herosectionBodyFirst"}
                    herosectionUnderlined={"Herosection-herosectionFirstUnderlined"}
                />
                <About />
                <Subjects />
                <Skills />
                {/* <CreateAccountForm /> */}
                <ClientCarousel />
                {/* <Companies /> */}
                {/* <ReachingOut /> */}
            </Box>
        );
    };
};


export default Home